module.exports = __webpack_public_path__ + "media/asset/images/AndoHazama/ITRI_company_team_AndoHazama-8b02a053a396ac4b1f35db0f87ffd4ff.png";